import React from 'react';
import Script from 'next/script';
import { isServer } from '@app/utils';

type Props = {
  identifier: string;
  payload: any;
  useNextScript?: boolean;
};
const WindowDataObject = ({
  identifier,
  payload,
  useNextScript = false,
}: Props) => {
  if (!isServer || !payload) {
    return null;
  }

  const load =
    typeof payload === 'object' ? JSON.stringify(payload) : `'${payload}'`;

  if (useNextScript) {
    return (
      <Script
        id={identifier}
        key={identifier}
      >{`window.${identifier}=${load}`}</Script>
    );
  }

  return (
    <script
      id={identifier}
      key={identifier}
      dangerouslySetInnerHTML={{
        __html: `
      window.${identifier} = ${load};
    `,
      }}
    />
  );
};

export default WindowDataObject;
